import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

// On Android/iOS, data lives in native Preferences (which the OS won't evict like
// WebView storage). Reads stay synchronous through an in-memory cache filled once
// by initStorage() before the app mounts. On the web this is plain localStorage.
const isNative = Capacitor.isNativePlatform();
const cache = new Map();

export const STORAGE_KEYS = ['gameState', 'gameHistory', 'celebratedGameId'];

export async function initStorage() {
  if (!isNative) return;
  await Promise.all(
    STORAGE_KEYS.map(async (key) => {
      const { value } = await Preferences.get({ key });
      if (value !== null) {
        cache.set(key, value);
        return;
      }
      // One-time migration from WebView localStorage.
      const legacy = localStorage.getItem(key);
      if (legacy !== null) {
        cache.set(key, legacy);
        await Preferences.set({ key, value: legacy });
      }
    })
  );
}

export function getItem(key) {
  if (isNative) return cache.has(key) ? cache.get(key) : null;
  return localStorage.getItem(key);
}

export function setItem(key, value) {
  if (isNative) {
    cache.set(key, value);
    Preferences.set({ key, value }).catch(() => {});
    return;
  }
  localStorage.setItem(key, value);
}
